import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Timesheets from '../../../Components/pages/timesheets/Timesheets';
import { getConstants } from '../../../actions/constFromApi';
import classes from './TimesheetsPage.module.scss';
import { getTandECountsContractor, getTandEPendingCounts } from '../../../actions/timesheet';
import AlternateMessageDialog from '../../../Components/common/AlternateMessageDialogComponent/AlternateMessageDialog';
import { TimesheetEmptyIcon } from '../../../Components/common/Icons';

export default function TimesheetsPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const constants = useSelector((state) => state.constFromApi);
  const isApprover = useSelector((state) => state.accessToParts.tAndEApprover);
  const timesheetPlacementStatus = useSelector((state) => state?.timesheet?.validate?.timesheet.IsValidPlacementStatus);
  const isTimesheetEmpty = useSelector((state) => state?.timesheet?.isTimesheetEmpty);
  const timesheetsPending = useSelector((state) => state.timesheet.pending);
  const [key, setKey] = useState(1);

  useEffect(() => {
    if (searchParams.has('status') && !searchParams.has('page')) {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!constants.clients?.length || !constants.worktypes?.length) dispatch(getConstants(true));
    dispatch(isApprover ? getTandEPendingCounts() : getTandECountsContractor());
  }, [constants.clients?.length, constants.worktypes?.length]);

  const handleAlternateMessageButton = () => {
    if (isApprover || !timesheetPlacementStatus) {
      return navigate('/dashboard');
    }

    return navigate('/dashboard/create-timesheet');
  };

  return (
    <section className={`${classes.pageContainer}`}>
      {!timesheetsPending && !isTimesheetEmpty ? (
        <Timesheets key={key} />
      ) : (
        <AlternateMessageDialog
          icon={<TimesheetEmptyIcon />}
          headerLabel={t('dashboard.createtimesheet.emptytimesheet')}
          startTracking={
            !isApprover
              ? t('dashboard.createtimesheet.starttrackingnow')
              : t('dashboard.createtimesheet.emptynotification')
          }
          mainButtonLabel={!isApprover ? t('dashboard.timesheets.newbuttontxt') : t('common.general.goback')}
          mainButtonEvent={() => handleAlternateMessageButton()}
          textButtonLabel={t('dashboard.createtimesheet.gotomaindashboard')}
          textButtonHandler="/dashboard"
          isApprover={isApprover}
          placementStatus={timesheetPlacementStatus}
        />
      )}
    </section>
  );
}
